import { render } from "./recovery_form.vue?vue&type=template&id=13ff0678"
import script from "./recovery_form.js?vue&type=script&lang=js"
export * from "./recovery_form.js?vue&type=script&lang=js"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__